module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flower3-4d2cb88fd8edfac3e86c99e51ace30a2.svg";